import Papa from "papaparse";
import { prepareDataForExport } from "../columnUtils/index.js";

// Export data to CSV file and trigger download
export const exportToCSV = ({ rows, columns, filename, formatCellValue }) => {
  try {
    if (!Array.isArray(rows) || rows.length === 0) {
      throw new Error("No data to export");
    }
    if (!Array.isArray(columns) || columns.length === 0) {
      throw new Error("No columns to export");
    }
    const { data } = prepareDataForExport({ rows, columns, formatCellValue });
    if (!Array.isArray(data) || data.length === 0) {
      throw new Error("Failed to prepare data for export");
    }

    const csv = Papa.unparse(data, {
      header: true,
      delimiter: ",",
      quotes: true,
      quoteChar: '"',
      escapeChar: '"',
      newline: "\n",
      skipEmptyLines: false
    });

    if (!csv || csv.length === 0) {
      throw new Error("Generated CSV is empty or invalid");
    }

    const lines = csv.split('\n');
    if (lines.length < 2) {
      throw new Error("CSV does not contain valid data rows");
    }

    const fileSizeMB = (csv.length / (1024 * 1024)).toFixed(2);
    console.log(`Exporting ${data.length} rows to CSV file: ${filename}.csv`);
    console.log(`CSV length: ${csv.length} characters (${fileSizeMB} MB)`);

    const BOM = '\uFEFF';
    const csvWithBOM = BOM + csv;

    const blob = new Blob([csvWithBOM], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);

    link.setAttribute("href", url);
    link.setAttribute("download", `${filename}.csv`);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);

  } catch (error) {
    console.error("Error exporting CSV:", error);
    throw new Error(`Failed to export CSV file: ${error.message}`);
  }
};

// Generate filename based on export type, filters, and column preset
export const generateExportFilename = ({ exportType, filters = [], columnPreset = "" }) => {
  const timestamp = new Date().toISOString().slice(0, 10);
  let filename = `influencer_data_${timestamp}`;
  if (exportType === "filtered" && filters.length > 0) {
    filename += "_filtered";
  } else if (exportType === "quick") {
    filename += "_quick";
  }
  if (columnPreset && columnPreset !== "default") {
    const presetSuffix = columnPreset.toLowerCase().replace(/\s+/g, "_");
    filename += `_${presetSuffix}`;
  }
  return filename;
};
